import React from 'react';
import type { SdpStatusEntry } from '../../api/contractStatus';
import ContractDetails from './ContractDetails';
import CopyContractLinkButton, { type ContractLinkType } from '../ui/CopyContractLinkButton';

interface ServiceDetailsModalProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  service: Record<string, any>;
  statusEntry?: SdpStatusEntry;
  // Basic (commodity) services carry no direction field; the parent knows which
  // list the row came from and passes it in (FT-4991).
  direction?: 'Injection' | 'Offtake';
  onClose: () => void;
}

const ServiceDetailsModal: React.FC<ServiceDetailsModalProps> = ({ service, statusEntry, direction, onClose }) => {
  const linkType: ContractLinkType | undefined =
    'sdp_flex_id' in service ? 'flex' : (direction?.toLowerCase() as 'injection' | 'offtake' | undefined);
  const linkId = service.contract_flex_id ?? service.contract_id;

  return (
    <div
      className='fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[200]'
      onClick={onClose}
    >
      <div
        className='bg-white dark:bg-primary-900 rounded-xl shadow-lg p-0 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto border border-primary-100 dark:border-primary-800'
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className='flex justify-between items-center px-6 py-4 border-b border-primary-100 dark:border-primary-800'>
          <h2 className='text-lg font-semibold text-primary-700 dark:text-white'>Service Details</h2>
          <div className='flex items-center gap-3'>
            {linkType && linkId != null && (
              <CopyContractLinkButton
                type={linkType}
                id={linkId}
                className='text-xs font-semibold px-3 py-1.5 rounded-md border border-primary-200 dark:border-primary-700 text-primary-600 dark:text-primary-200 hover:bg-primary-50 dark:hover:bg-primary-800 transition'
              />
            )}
            <button
              onClick={onClose}
              className='text-gray-400 hover:text-primary-600 dark:hover:text-primary-200 text-xl transition'
              aria-label='Close'
            >
              &times;
            </button>
          </div>
        </div>

        {/* Content */}
        <div className='px-6 py-4'>
          <ContractDetails service={service} statusEntry={statusEntry} direction={direction} />
        </div>
      </div>
    </div>
  );
};

export default ServiceDetailsModal;
